import React from 'react';
import PropTypes from 'prop-types';

const ReviewHeader = ({ fromLabel, toLabel, amtLabel, refLabel, dateLabel, typeLabel }) => (
	<div className="c-m-payment-review c-m-payment-review--header">
		<div className="c-m-payment-review__row c-m-payment-review__row--double">
			<span className="c-m-payment-review__label">{fromLabel}</span>
		</div>

		<div className="c-m-payment-review__row c-m-payment-review__row--double">
			<span className="c-m-payment-review__label">{toLabel}</span>
		</div>

		<div className="c-m-payment-review__row">
			<span className="c-m-payment-review__label">{amtLabel}</span>
		</div>

		<div className="c-m-payment-review__row c-m-payment-review__row--ref">
			<span className="c-m-payment-review__label">{refLabel}</span>
		</div>

		<div className="c-m-payment-review__row">
			<span className="c-m-payment-review__label">{dateLabel}</span>
		</div>

		<div className="c-m-payment-review__row">
			<span className="c-m-payment-review__label">{typeLabel}</span>
		</div>
	</div>
);

ReviewHeader.propTypes = {
	fromLabel: PropTypes.string.isRequired,
	toLabel: PropTypes.string.isRequired,
	amtLabel: PropTypes.string.isRequired,
	refLabel: PropTypes.string.isRequired,
	dateLabel: PropTypes.string.isRequired,
	typeLabel: PropTypes.string.isRequired,
};

export default ReviewHeader;
